<template>
  <div>
    <v-card class="my-4" outlined>
      <v-card-title class="subtitle-1 font-weight-bold">
        <v-icon left class="mr-2">mdi-account-multiple-plus</v-icon>
        {{ $t("user_addition_result") }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div
          v-if="employees.existing_users && employees.existing_users.length"
          class="mt-4"
        >
          <v-row align="center" class="mt-4" no-gutters>
            <v-chip color="error" text-color="white" class="mr-2">
              <v-icon left small>mdi-account-check</v-icon>
              {{ employees.existing_users.length }}
            </v-chip>
            <span class="font-weight-bold">
              {{ $t("users_not_added_username_taken") }}
            </span>
          </v-row>
          <v-row dense>
            <v-col cols="auto" v-for="user in employees.existing_users" :key="user.id">
              <v-chip class="ma-1" outlined>
                <v-icon left small color="error">mdi-account</v-icon>
                <span class="font-weight-bold">
                  {{ toLatin(user.name) }} {{ toLatin(user.lastname) }}
                </span>
              </v-chip>
            </v-col>
          </v-row>
        </div>

        <div v-if="employees.new_users && employees.new_users.length" class="mt-4">
          <company-employees-qr-table
            :employees="employees.new_users"
            bigger-button
            @fieldsUpdated="visibleFields = $event"
          >
            <template #additional-actions>
              <div class="ml-2">
                <employee-button-print
                  :employees="employees.new_users"
                  :headers="headersForPrint"
                  bigger-button
                  height="40px"
                  :title="parentCompany?.name || ''"
                ></employee-button-print>
              </div>
            </template>
          </company-employees-qr-table>

          <v-row align="center" class="mb-2 mt-4" no-gutters>
            <v-chip color="success" text-color="white" class="mr-2">
              <v-icon left small>mdi-account-plus</v-icon>
              {{ employees.new_users.length }}
            </v-chip>
            <span class="font-weight-bold">
              {{ $t("new_users_added") }}
            </span>
          </v-row>
          <v-row dense>
            <v-col
              cols="12"
              md="6"
              lg="4"
              v-for="employee in employees.new_users"
              :key="employee.id"
              class="mb-4"
            >
              <v-card outlined class="pa-3">
                <v-row no-gutters>
                  <v-col cols="auto" class="pr-2">
                    <qrcode-vue
                      :id="`qrkodstampa${employee.id}`"
                      :value="
                        JSON.stringify({
                          id: employee.id,
                          secure: employee.qrCode,
                        })
                      "
                      :size="120"
                      level="H"
                      render-as="svg"
                    />
                  </v-col>
                  <v-col>
                    <div
                      class="font-weight-bold mb-1"
                      style="font-size: 16px"
                      v-if="visibleFields.includes(2)"
                    >
                      <v-icon left small color="primary">mdi-account</v-icon>
                      {{ toLatin(employee.name) }}
                      {{ toLatin(employee.lastname) }}
                    </div>
                    <div
                      v-if="visibleFields.includes(3)"
                      class="grey--text text--darken-2 mb-1"
                      style="font-size: 13px"
                    >
                      <v-icon left small color="primary">mdi-email</v-icon>
                      {{ employee.email }}
                    </div>
                    <div
                      v-if="visibleFields.includes(1)"
                      class="grey--text text--darken-2 mb-1"
                      style="font-size: 13px"
                    >
                      <v-icon left small color="primary">mdi-identifier</v-icon>
                      Ordera ID:
                      <span class="font-weight-bold">{{ employee.id }}</span>
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </div>

        <div
          v-if="employees.no_email_users && employees.no_email_users.length"
          class="mt-4"
        >
          <v-row align="center" class="mb-2" no-gutters>
            <v-chip color="error" text-color="white" class="mr-2">
              <v-icon left small>mdi-alert</v-icon>
              {{ employees.no_email_users.length }}
            </v-chip>
            <span class="font-weight-bold">
              {{ $t("users_without_email_not_added") }}
            </span>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import hasPrinting from "@/mixins/hasPrinting";
import EmployeeButtonPrint from "@/components/company/employee/buttons/EmployeeButtonPrint.vue";
import CompanyEmployeesQrTable from "@/components/company/employee/tables/CompanyEmployeesQrTable.vue";

export default {
  name: "CompanyEmployeeQuickAddDetailedDialog",
  mixins: [hasPrinting],
  components: {
    QrcodeVue,
    EmployeeButtonPrint,
    CompanyEmployeesQrTable,
  },
  props: {
    employees: {
      type: Object,
      default: () => ({}),
    },
    parentCompany: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    visibleFields: [1, 2, 3],
  }),
  computed: {
    headersForPrint() {
      return [
        {
          text: this.$t("name"),
          value: "name",
        },
        {
          text: this.$t("last_name"),
          value: "lastname",
        },
        {
          text: this.$t("email"),
          value: "email",
        },
        {
          text: this.$t("external_code"),
          value: "external_code",
        },
        {
          text: this.$t("password"),
          value: "password",
        },
        {
          text: this.$t("user_type"),
          value: "type",
        },
      ];
    },
  },
};
</script>
